// src/services/exerciseService.js
import api from './api';

export const getAllExercises = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/exercises?${params}`);
  return response.data;
};

export const getExerciseById = async (id) => {
  const response = await api.get(`/exercises/${id}`);
  return response.data;
};

export const createExercise = async (exerciseData) => {
  const response = await api.post('/exercises', exerciseData);
  return response.data;
};

export const updateExercise = async (id, exerciseData) => {
  const response = await api.put(`/exercises/${id}`, exerciseData);
  return response.data;
};

export const deleteExercise = async (id) => {
  const response = await api.delete(`/exercises/${id}`);
  return response.data;
};

export const activateExercise = async (id) => {
  const response = await api.post(`/exercises/${id}/activate`);
  return response.data;
};

export const closeExercise = async (id) => {
  const response = await api.post(`/exercises/${id}/close`);
  return response.data;
};

export const cloneCommands = async (id, sourceExerciseId) => {
  const response = await api.post(`/exercises/${id}/clone-commands`, {
    sourceExerciseId,
  });
  return response.data;
};

export const previewClonePersonnel = async (id, sourceExerciseId) => {
  const response = await api.post(`/exercises/${id}/clone-personnel/preview`, {
    sourceExerciseId,
  });
  return response.data;
};

export const clonePersonnel = async (id, sourceExerciseId) => {
  const response = await api.post(`/exercises/${id}/clone-personnel`, {
    sourceExerciseId,
  });
  return response.data;
};
